// * This is a higher order component that wraps a video player component and provides it with scroll detection on when the video should start to play. Once the video is finished playing it switches to a static image if one is provided
import { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';

import VideoPlayer from '../VideoPlayer';

export const withDynamicVideo = VideoModule => {
  const DynamicVideoPlayer = ({
    className = '',
    url,
    loop = false,
    controls = true,
  }) => {
    const ref = useRef(null);
    let video;

    const [state, setState] = useState({
      playing: false,
      played: false,
      loaded: false,
    });

    // * Create a reference to the component after mounting & listen for when its finished playing
    useEffect(() => {
      video = ref.current ? ref.current.getInternalPlayer() : false;
      if (video) video.addEventListener('ended', videoPlayedThrough);
    }, []);

    // * Removes the event listeners and resets state once the video is fully played
    const videoPlayedThrough = () => {
      if (video) video.removeEventListener('ended', videoPlayedThrough);
      setState(prevState => {
        const newState = { playing: false, played: true };
        return { ...prevState, ...newState };
      });
    };

    // * Plays the video once scrolled into view
    const onChange = isVisible => {
      // * if (!video) return; // * No video loadeed, dont do anything
      if (isVisible && !state.played) {
        setState(prevState => {
          const newState = { playing: true };
          return { ...prevState, ...newState };
        });
      }
    };

    return (
      <VisibilitySensor onChange={onChange}>
        <VideoModule
          className={className}
          ref={ref}
          url={url}
          playing={state.playing}
          loop={loop}
          controls={controls}
          muted
        />
      </VisibilitySensor>
    );
  };
  DynamicVideoPlayer.propTypes = {
    className: PropTypes.string,
    url: PropTypes.string.isRequired,
    loop: PropTypes.bool,
    controls: PropTypes.bool,
  };
  return DynamicVideoPlayer;
};

export default withDynamicVideo(VideoPlayer);
